import {
  FilterType,
  buildEmployeePulseEmployeeDatatableFilter,
  useEmployeePulseEmployeeDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

const managerFilter = (source: ReturnType<typeof useEmployeePulseEmployeeDatatable>) => {
  return buildEmployeePulseEmployeeDatatableFilter(source, {
    title: i18n.t('engagement.pulse.dashboard.datatable.filters.manager'),
    path: 'managerId',
    identifier: 'managerId',
    type: FilterType.Entity,
    default: true,
    categories: [
      {
        kind: 'Employee',
        operation: 'in',
      },
    ],
  })
}

export default managerFilter
